import React, {Fragment, useState} from "react";
import {UncontrolledPopover} from "reactstrap";
// @ts-ignore
import ThreeDots from '@assets/images/mi_options-vertical.svg';
import {
    CustomHeader,
    OptionContainer,
    OptionsContainer,
} from "@pages/new-design-components/custom-components";
interface IProps {
    index: number;
    showQuickView: boolean;
    withoutDelete: boolean;
    quickView: (index: number | string)=>void;
    goToDetails: (index:  number | string)=>void;
    deleteContent: (index:  number | string)=>void;
}
const Uncontrolled: React.FC<IProps> = ({index,quickView,showQuickView,goToDetails,withoutDelete,deleteContent}) => {

    const [showPopover, setShowPopover] = useState<boolean>(false);
    const togglePopover: () => void = () => {
        setShowPopover(!showPopover);
    }

    return (<Fragment key={index}>
        <img src={ThreeDots} id={`PopoverLegacy_${index}`} />
        <UncontrolledPopover
            placement="left"
            className="fleet-popover"
            target={`PopoverLegacy_${index}`}
            trigger="legacy"
            isOpen={showPopover}
            toggle={()=>{togglePopover()}}
        >
            <OptionsContainer className={'cursor-pointer'}>
                {
                    showQuickView &&
                    <OptionContainer
                        onClick={()=>{
                            quickView(index)
                            togglePopover()
                        }}
                    >
                        <CustomHeader  fontSize={'14px'} weight={'400'}>
                            Quick View
                        </CustomHeader>

                    </OptionContainer>
                }
                <OptionContainer
                    onClick={()=>{
                        goToDetails(index)
                    }}
                >
                    <CustomHeader  fontSize={'14px'} weight={'400'}>
                        Edit
                    </CustomHeader>

                </OptionContainer>

                {!withoutDelete &&  <OptionContainer
                    onClick={() =>  deleteContent(index)}
                >
                    <CustomHeader fontSize={'14px'} weight={'400'}>
                        Delete
                    </CustomHeader>
                </OptionContainer>}


            </OptionsContainer>
        </UncontrolledPopover>
        </Fragment>)
}
export default Uncontrolled;